export default __webpack_public_path__ + "static/TT_Commons_Pro_Trial_Normal-f285c6bd9f2e3b9bc776ebb6e0b38fb5.woff2";